<div class=" col-sm-12 col-md-12 col-lg-12">
    <div class="homeCompNav">
        
    </div> 
    <router-outlet></router-outlet>
</div>